import React, { useContext, useMemo } from "react";
import UserTrainingContext from "../../../../context/userTrainingContext";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import Spinner from "../../../../components/Spinner";
import { useTranslation } from "react-i18next";
import * as r from "../../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { prettySubPathUrl } from "../../../../helpers";
import CardTraining from "../CardTraining";
import { Grid } from "@mui/material";
import IconChat from "../../../../assets/images/usersGo/chat.svg";
import IconBrain from "../../../../assets/images/usersGo/brain.svg";
import IconHearing from "../../../../assets/images/usersGo/hearing.svg";
import IconTarget from "../../../../assets/images/usersGo/target.svg";
import IconRay from "../../../../assets/images/usersGo/ray.svg";

export default function TabTraining() {
  const tContext = useContext(UserTrainingContext);
  const history = useNavigate();
  const { t } = useTranslation();

  // Habilidades que devem aparecer na tela
  const skillsInfo = [
    {
      name: "agilidade mental",
      title: "Agilidade Mental",
      text: t("global.exercises_in_rapid_processing_and_decision_making"),
      icon: <img src={IconRay} alt="Agilidade Mental" />,
    },
    {
      name: "foco",
      title: "Foco",
      text: t("global.train_your_attention_and_concentration_skills"),
      icon: <img src={IconTarget} alt="Foco" />,
    },
    {
      name: "memória",
      title: "Memória",
      text: t("global.train_your_ability_to_store_and_retrieve_information"),
      icon: <img src={IconBrain} alt="Memória" />,
    },
    {
      name: "escuta ativa",
      title: "Escuta Ativa",
      text: t("global.strengthen_information_retention_and_recognition"),
      icon: <img src={IconHearing} alt="Escuta Ativa" />,
    },
    {
      name: "linguagem",
      title: "Linguagem",
      text: t("global.develop_comprehension_and_communication_skills"),
      icon: <img src={IconChat} alt="Linguagem" />,
    },
  ];

  const availableSkills = useMemo(() => {
    // Pega todas as habilidades de todos os jogos em uma lista só
    const abilities = tContext?.game_list?.flatMap(
      (game: any) => game.abilities || [],
    );

    // Remove duplicados
    const uniqueAbilities = new Set(abilities);

    // Filtra só as skills que existem nos jogos selecionados no objeto
    const filteredtest = skillsInfo.filter((skill) =>
      uniqueAbilities.has(skill.name),
    );

    return filteredtest;
  }, [tContext.game_list]);


  if (!tContext?.game_list) {
    return <Spinner center />;
  }

  if (tContext?.game_list && tContext?.game_list.length === 0) {
    return (
      <FriendlyInfo
        isError
        text={t("infos.error_to_fetch_info_try_to_reload")}
      />
    );
  }

  return (
    <Grid container spacing={2} maxWidth={900} sx={{ margin: "0 auto" }}>
      {availableSkills.map((skill) => (
        <Grid size={{ xs: 12, sm: 6 }} key={skill.title}>
          <CardTraining
            text={skill.text}
            title={skill.title}
            buttonText="Começar"
            icon={skill.icon}
            onClick={() => {
              history(r.GET_R_U_TRAIN_CAT(prettySubPathUrl(skill.title)));
              tContext.setActiveCategory(skill.title);
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
